import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import Loading from "@/components/home/Loading.vue";
import { ref, onMounted, reactive } from "vue";
import StationForSystemDataService from "@/services/StationForSystemDataService";

import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const i18n = useI18n();
const title = ref("New SCAN-PC Batch Control");
const title1 = ref("Edit SCAN-PC Batch Control");
const stationCodeInfo = reactive([]);
const system = ref("FTP"); // AS400が2024年03末に停止された後、FTPのみデフォルト設定する
const FTPUserId = ref("");
const FTPUserIdData = ref("");
const selectedStationCode = ref("");
const stationId = ref("");
const dataId = ref("");
const alertMessage = ref("null");
const alertState = ref("neutral");
const FTPUserIdError = ref("");
const stationCodeError = ref("");
const dataIdError = ref("");
const duplicateError = ref("");
const isDuplicate = ref(false);

onMounted(function () {
  isLoading.value = true;
  if (store.getters.id != "") {
    stationId.value = store.getters.id;
    selectedStationCode.value = store.getters.selectedStation;
    dataId.value = store.getters.dataId;
    if (dataId.value == null) {
      dataId.value = "";
    }
    system.value = "FTP";
    FTPUserId.value = store.getters.ftpUserId;
    FTPUserIdData.value = store.getters.ftpUserId;
    if (store.getters.ftpUserId == null) {
      FTPUserId.value = "";
      FTPUserIdData.value = "";
    }
  }
  getStationCodeList();
  isLoading.value = false;
});

const getStationCodeList = () => {
  stationCodeInfo.splice(0);
  if(store.getters.stationListData != null){
    for(let stObj of store.getters.stationListData){
      stationCodeInfo.push(stObj);
    }
  }
}

const btnRegisterClick = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  isDuplicate.value = false;
  FTPUserIdError.value = "";
  stationCodeError.value = "";
  dataIdError.value = "";
  duplicateError.value = "";
  var inputOK1,
    inputOK2,
    inputOK3 = false;
  FTPUserId.value = FTPUserId.value.toUpperCase();
  dataId.value = dataId.value.toUpperCase();
  inputOK1 = validFTPUserId(FTPUserId.value);
  inputOK2 = validStationCode(selectedStationCode.value);
  inputOK3 = validDataId(dataId.value);
  if (inputOK1 && inputOK2 && inputOK3) {
    const data = {
      id: stationId.value,
      FTPUserId: FTPUserId.value,
      stationCode: selectedStationCode.value,
      dataId: dataId.value,
    };
    isLoading.value = true;
    if (stationId.value == "") {
      /** データ登録処理 */
      StationForSystemDataService.insertStaionCodeForSystem(data)
        .then((response: ResponseData) => {
          if (response.data.message != "success") {
            alertMessage.value = response.data.message;
            alertState.value = "error";
            isLoading.value = false;
          } else {
            var insertedPcData = response.data.pcData;
            var oriPcCompanyList = [];
            var isAdded = false;
            for(let pcComObj of store.getters.pcCompanyListData){
              if(insertedPcData[0].stationCode.stationCode < pcComObj.stationCode.stationCode && !isAdded){
                oriPcCompanyList.push(insertedPcData[0]);
                isAdded = true;
              }
              oriPcCompanyList.push(pcComObj);
            }
            if(isAdded== false){
              oriPcCompanyList.push(insertedPcData[0]);
            }
            store.dispatch("setPcCompanyListData", oriPcCompanyList);
            alertMessage.value = i18n.t("suc026");
            alertState.value = "success";
            isLoading.value = false;
          }
        })
        .catch((_) => {
          alertMessage.value = i18n.t("err052");
          alertState.value = "error";
          isLoading.value = false;
        });
    } else {
      /** データ編集処理 */
      StationForSystemDataService.updateStaionCodeForSystem(data)
        .then((response: ResponseData) => {
          if (response.data.message != "success") {
            alertMessage.value = response.data.message;
            alertState.value = "error";
            isLoading.value = false;
          } else {
            var updatedPcData = response.data.pcData;
            var oriPcCompanyList = [];
            for(let pcComObj of store.getters.pcCompanyListData){
              if(updatedPcData[0].id == pcComObj.id){
                oriPcCompanyList.push(updatedPcData[0]);
              }else{
                oriPcCompanyList.push(pcComObj);
              }
            }
            store.dispatch("setPcCompanyListData", oriPcCompanyList);
            alertMessage.value = i18n.t("suc025");
            alertState.value = "success";
            isLoading.value = false;
          }
        })
        .catch((_) => {
          alertMessage.value = i18n.t("err047");
          alertState.value = "error";
          isLoading.value = false;
        });
    }
    // }
  }
};

/** FTPUserIdチェック機能 */
const validFTPUserId = (FTPUserID: string) => {
  FTPUserIdError.value = "";
  var re = /^[A-Za-z0-9]+$/;
  var result = true;
  if (system.value !== "") {
    if (system.value == "FTP") {
      if (FTPUserID.trim() == "") {
        result = false;
        FTPUserIdError.value = i18n.t("alt035");
      } else if (!re.test(FTPUserID.trim())) {
        FTPUserIdError.value = i18n.t("alt036");
        result = false;
      }
    }
  } else {
    if (FTPUserIdData.value !== "") {
      if (FTPUserID.trim() == "") {
        result = false;
        FTPUserIdError.value = i18n.t("alt035");
      } else if (!re.test(FTPUserID.trim())) {
        FTPUserIdError.value = i18n.t("alt036");
        result = false;
      }
    }
  }
  return result;
};

const stationChange = (event: { target: { value: any; }; }) => {
  selectedStationCode.value = event.target.value;
  validStationCode(selectedStationCode.value);
};

/** StationCodeチェック機能 */
const validStationCode = (stationCd: string) => {
  stationCodeError.value = "";
  var result = true;
  if (stationCd.trim() == "") {
    stationCodeError.value = i18n.t("alt040");
    result = false;
  }
  return result;
};

/** DataIdチェック機能 */
const validDataId = (dataId: string) => {
  dataIdError.value = "";
  var re = /^[A-Za-z]+$/;
  var result = true;
  if (dataId.trim() == "") {
    return result;
  } else if (dataId.trim().length != 4) {
    dataIdError.value = i18n.t("alt037");
    result = false;
  } else if (dataId.trim().length != 4) {
    dataIdError.value = i18n.t("alt038");
    result = false;
  } else if (!re.test(dataId.trim())) {
    result = false;
    dataIdError.value = i18n.t("alt038");
  }
  return result;
};

/** back button */
const backbtnEvt = () => {
  store.dispatch("setShowPage", "StationCodeForSystemList");
};

const __returned__ = { isLoading, i18n, title, title1, stationCodeInfo, system, FTPUserId, FTPUserIdData, selectedStationCode, stationId, dataId, alertMessage, alertState, FTPUserIdError, stationCodeError, dataIdError, duplicateError, isDuplicate, getStationCodeList, btnRegisterClick, validFTPUserId, stationChange, validStationCode, validDataId, backbtnEvt, AdminNavigation, Alert, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})